export const FNOLCOMPONENT_HEADER = "FnolHeader";
export const FNOLCOMPONENT_TEXTBOX = "FnolTextbox";
export const FNOLCOMPONENT_AUTOCOMPLETE = "FnolAutoComplete";
export const FNOLCOMPONENT_CHECKBOX = "FnolCheckbox";
export const FNOLCOMPONENT_DATATIMEPICKER = "FnolDateTimePicker";
export const FNOLCOMPONENT_DATEPICKER = "FnolDatePicker";
export const FNOLCOMPONENT_DROPDOWN = "FnolDropdown";
export const FNOLCOMPONENT_MULTIOPTIONDROPDOWN = "FnolMultiOptionDropdown";
export const FNOLCOMPONENT_RADIOBUTTON = "FnolRadioButton";
export const FNOLCOMPONENT_ADDRESSFORM = "FnolAddressForm";
export const FNOLCOMPONENT_PASSENGERBLOCK = "FnolPassengers";
export const FNOLCOMPONENT_PASSENGERBLOCKV2 = "FnolPassengersV2";
export const FNOLCOMPONENT_THIRDPARTYBLOCK = "FnolThirdParty";
export const FNOLCOMPONENT_RecoveryLocation = "FnolRecoveryLocationLookup";
export const FNOLCOMPONENT_CUSTOMERBUSINESSHIERARCHY = "FnolCustomerBusinessHierarchy";
export const FNOLCOMPONENT_FNOLCOMPLETE = "FnolComplete";
export const FNOLCOMPONENT_LABEL = "FnolLabel";
export const FNOLCOMPONENT_DOCUMENTUPLOADER = "FnolDocumentUploader";
export const AUTO_POPULATED_BY = "autoPopulatedBy";
export const blockComponentTypes = [
  FNOLCOMPONENT_PASSENGERBLOCK,
  FNOLCOMPONENT_PASSENGERBLOCKV2,
  FNOLCOMPONENT_CUSTOMERBUSINESSHIERARCHY,
  FNOLCOMPONENT_ADDRESSFORM,
  FNOLCOMPONENT_THIRDPARTYBLOCK,
];

export const FNOLCOMPONENTLISTDETAILS = [
  {
    key: FNOLCOMPONENT_HEADER,
    buttonText: "Header",
    buttonImage: "header",
    controlType: FNOLCOMPONENT_HEADER,
    onlyOneUse: false,
    visibleInToolbox: true,
    fieldMappingId: "header",
  },
  {
    key: FNOLCOMPONENT_LABEL,
    buttonText: "Label",
    buttonImage: "font",
    controlType: FNOLCOMPONENT_LABEL,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_TEXTBOX,
    buttonText: "Text Box",
    buttonImage: "font",
    controlType: FNOLCOMPONENT_TEXTBOX,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_AUTOCOMPLETE,
    buttonText: "Auto Complete",
    buttonImage: "chevron circle down",
    controlType: FNOLCOMPONENT_AUTOCOMPLETE,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_CHECKBOX,
    buttonText: "Check Box",
    buttonImage: "check square outline",
    controlType: FNOLCOMPONENT_CHECKBOX,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_DATATIMEPICKER,
    buttonText: "Date Time Picker",
    buttonImage: "calendar alternate outline",
    controlType: FNOLCOMPONENT_DATATIMEPICKER,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_DATEPICKER,
    buttonText: "Date Picker",
    buttonImage: "calendar alternate outline",
    controlType: FNOLCOMPONENT_DATEPICKER,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_DROPDOWN,
    buttonText: "Drop Down",
    buttonImage: "chevron circle down",
    controlType: FNOLCOMPONENT_DROPDOWN,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_MULTIOPTIONDROPDOWN,
    buttonText: "Multi Option Drop Down",
    buttonImage: "chevron circle down",
    controlType: FNOLCOMPONENT_MULTIOPTIONDROPDOWN,
    fieldMappingControl: FNOLCOMPONENT_DROPDOWN,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_RADIOBUTTON,
    buttonText: "Radio Button",
    buttonImage: "chevron circle down",
    controlType: FNOLCOMPONENT_RADIOBUTTON,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_ADDRESSFORM,
    buttonText: "Address Form",
    buttonImage: "address book",
    controlType: FNOLCOMPONENT_ADDRESSFORM,
    onlyOneUse: false,
    visibleInToolbox: true,
  },
  {
    key: FNOLCOMPONENT_PASSENGERBLOCK,
    buttonText: "Passenger Block",
    buttonImage: "passenger",
    controlType: FNOLCOMPONENT_PASSENGERBLOCK,
    onlyOneUse: true,
    visibleInToolbox: true,
    fieldMappingId: "passengers",
    controlLocation: "passenger-control/FnolPassengers",
  },
  {
    key: FNOLCOMPONENT_THIRDPARTYBLOCK,
    buttonText: "Third Party Block",
    buttonImage: "thirdparty",
    controlType: FNOLCOMPONENT_THIRDPARTYBLOCK,
    onlyOneUse: true,
    visibleInToolbox: true,
    fieldMappingId: "thirdParties",
  },
  {
    key: FNOLCOMPONENT_CUSTOMERBUSINESSHIERARCHY,
    buttonText: "Business Hierarchy",
    buttonImage: "customerBusiness",
    controlType: FNOLCOMPONENT_CUSTOMERBUSINESSHIERARCHY,
    onlyOneUse: true,
    visibleInToolbox: true,
    fieldMappingId: "customerBusinessHierarchy",
  },
  {
    key: FNOLCOMPONENT_FNOLCOMPLETE,
    controlType: FNOLCOMPONENT_FNOLCOMPLETE,
    visibleInToolbox: false,
  },
  {
    key: FNOLCOMPONENT_RecoveryLocation,
    buttonText: "Recovery Location",
    buttonImage: "recoveryLocation",
    controlType: FNOLCOMPONENT_RecoveryLocation,
    onlyOneUse: true,
    visibleInToolbox: true,
    fieldMappingId: "recoveryLocation",
  },
  {
    key: FNOLCOMPONENT_DOCUMENTUPLOADER,
    buttonText: "Document Uploader",
    controlType: FNOLCOMPONENT_DOCUMENTUPLOADER,
    onlyOneUse: true,
    visibleInToolbox: true,
    fieldMappingId: "documentUploader",
  },
];
